import { cva } from 'class-variance-authority';

export const inputRootVariants = cva(
  [
    '[&>svg]:fill-current',
    'flex',
    'search-input-none',
    // 'relative',
    'items-center',
    'self-stretch',
    'relative',
    'rounded-radius-comp-form-round',
    //default
    'bg-color-comp-text-field-container-enabled',
    '[&>input]:text-color-comp-text-field-on-container-enabled',
    //hover
    'hover:bg-color-comp-text-field-container-hover',
    //read-only:
    'has-[input:read-only:not(:disabled):not([role="combobox"])]:bg-color-comp-text-field-container-read-only',
    'has-[input:read-only:not(:disabled):not([role="combobox"])]:text-color-comp-text-field-on-container-selected',
    //focus
    'has-[input:focus]:bg-color-comp-text-field-container-selected',
    'has-[input:focus]:text-color-comp-text-field-on-container-selected',
    //active
    'has-[input:active]:bg-color-comp-text-field-container-selected',
    'has-[input:active]:text-color-comp-text-field-on-container-selected',
    //visited
    'has-[input:visited]:bg-color-comp-text-field-container-entered',
    'has-[input:visited]:text-color-comp-text-field-on-container-selected',
    //disabled
    'has-[input:disabled]:bg-color-comp-text-field-container-disabled',
    'has-[input:disabled]:text-color-comp-text-field-on-container-disabled',
    //error
    'has-[input:invalid]:text-color-comp-text-field-on-container-selected',
    'has-[input[aria-invalid="true"]]:text-color-comp-text-field-on-container-selected',
    //not empty
    'has-[input:not([value=""])]:text-color-comp-text-field-on-container-selected',

    // BORDER WIDTH DEFINITION
    'before:absolute',
    'before:top-0',
    'before:right-0',
    'before:left-0',
    'before:bottom-0',
    'before:content-[""]',
    'before:rounded-radius-comp-form-round',
    'before:border-solid',
    'before:border-border-comp-text-field',
    //hover
    'before:hover:border-color-comp-text-field-border-hover',
    //read-only:
    'before:has-[input:read-only:not(:disabled):not([role="combobox"])]:border-color-comp-text-field-border-read-only',
    //focus
    'before:has-[input:focus:not(:read-only)]:border-color-comp-text-field-border-selected',
    //active
    'before:has-[input:active:not(:read-only)]:border-color-comp-text-field-border-selected',
    //visited
    'before:has-[input:visited]:border-color-comp-text-field-border-entered',
    //disabled
    'before:has-[input:disabled]:border-color-comp-text-field-border-disabled',
    //error
    'before:has-[input:invalid]:border-color-comp-text-field-border-danger',
    'before:has-[input[aria-invalid="true"]]:border-color-comp-text-field-border-danger',
    //not empty
  ],
  {
    variants: {
      inputSize: {
        small: [
          'font-comp-text-field-web-small-text-font-family',
          'font-comp-text-field-web-small-text-font-weight',
          // font-size BEFORE leading: twMerge keeps Tailwind's default
          // font-size→clears-leading conflict, so a later font-size would drop
          // the line-height token (see @latitude/token-utils cn).
          'text-font-comp-text-field-web-small-text-font-size',
          'leading-font-comp-text-field-web-small-text-line-height',
          'py-spacing-comp-text-field-small-vertical',
          'pl-spacing-comp-text-field-small-horizontal-left',
          'pr-spacing-comp-text-field-small-horizontal-right',
        ],
        medium: [
          'font-comp-text-field-web-medium-text-font-family',
          'font-comp-text-field-web-medium-text-font-weight',
          // font-size BEFORE leading: see small variant above.
          'text-font-comp-text-field-web-medium-text-font-size',
          'leading-font-comp-text-field-web-medium-text-line-height',
          'py-spacing-comp-text-field-medium-vertical',
          'pl-spacing-comp-text-field-medium-horizontal-left',
          'pr-spacing-comp-text-field-medium-horizontal-right',
          // Standard inline form-element height: 40px (CEXP-21573)
          'min-h-sizing-sys-size-40',
        ],
      },
      hasError: {
        true: [
          'before:border-color-comp-text-field-border-danger',
          'text-color-comp-text-field-on-container-selected',
        ],
        false: [
          'before:border-color-comp-text-field-border-enabled',
          'text-color-comp-text-field-on-container-enabled',
        ],
      },
    },
    defaultVariants: {
      inputSize: 'medium',
      hasError: false,
    },
  },
);

export const contentWrapper = cva(
  'relative flex flex-1 min-w-0 flex-row flex-wrap items-center justify-start space-x-1',
  {
    variants: {
      inputSize: {
        small: [
          'py-spacing-comp-text-field-small-text-area-vertical',
          'px-spacing-comp-text-field-small-text-area-horizontal',
          'text-font-comp-text-field-web-small-text-font-size',
          'gap-spacing-comp-text-field-small-gap',
          'min-h-sizing-sys-size-24',
          'leading-4',
        ],
        medium: [
          'py-spacing-comp-text-field-medium-text-area-vertical',
          'px-spacing-comp-text-field-medium-text-area-horizontal',
          'gap-spacing-comp-text-field-medium-gap',
          'text-font-comp-text-field-web-medium-text-font-size',
          'min-h-sizing-sys-size-24',
          'leading-6',
        ],
      },
    },
    defaultVariants: {
      inputSize: 'medium',
    },
  },
);
